import { Component, Input, OnInit } from '@angular/core';
import { SportListComponent } from '../sport-list.component';

@Component({
  selector: 'app-d-sport-list',
  templateUrl: './d-sport-list.component.html',
  styleUrls: ['./d-sport-list.component.css']
})
export class DSportListComponent extends SportListComponent implements OnInit {
  public data: any;
  @Input() list!: any;
  @Input() viewBy: any = 't';
  @Input() eventId!: any;
  @Input() oddsData!: any;

  ngOnInit(): void {
    // if(!this.actRoute.snapshot.paramMap.get('id')) {this.getData();}
  }

  ngOnChanges() {
    if (this.list) {
      if (this.viewBy == 'c') {
        if (this.eventId == 'in_play') {
          this.data = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByinPlayCat(this.list);
        } else {
          this.data = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByTypeIdCat(this.list, this.eventId);
        }
      } else {
        if (this.eventId == 'in_play') {
          this.data = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByinPlay(this.list);
        } else {
          this.data = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByTypeId(this.list, this.eventId);
        }
      }

      if (this.eventId == 'in_play') {
        this.datalength = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByinPlayData(this.list);
      } else {
        this.datalength = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByTypeIdData(this.list, this.eventId);
      }

      this.odds = this.oddsData;
      this.eId = this.eventId;
    }

  }

}
